import { CdkColumnDef } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { AppCommonModule } from '../../app-common.module';
import { SupplyChainDirectCommonModule } from './supply-chain-direct-common.module';
import { SupplyChainDirectRoutingModule } from './supply-chain-direct-routing.module';
import { SupplyChainDirectComponent } from './supply-chain-direct.component';

@NgModule({
    imports: [
        LsqCommonModule.forChild(),
        LsqTablesModule.forRoot(),
        AppCommonModule,
        SupplyChainDirectCommonModule,
        SupplyChainDirectRoutingModule
    ],
    declarations: [SupplyChainDirectComponent],
    providers: [CdkColumnDef]
})
export class SupplyChainDirectModule {}
